module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form__input-container"
  }, [_c('fieldset', {
    staticClass: "form__field"
  }, [(_vm.label) ? _c('label', {
    staticClass: "form__label",
    attrs: {
      "for": "control"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.L.localize(_vm.label)) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('select', {
    staticClass: "form__select",
    attrs: {
      "id": "control",
      "disabled": _vm.disabled,
      "data-acc": _vm.acc,
      "name": _vm.acc
    },
    domProps: {
      "value": _vm.value
    },
    on: {
      "input": function($event) {
        return _vm.updateValue($event.target.value)
      },
      "change": _vm.onChange
    }
  }, _vm._l((_vm.options), function(option) {
    return _c('option', {
      attrs: {
        "disabled": option.isDisabled
      },
      domProps: {
        "value": option.value !== undefined ? option.value : option
      }
    }, [_vm._v("\n            " + _vm._s(option.label ? option.label : option) + "\n        ")])
  }), 0)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-76aa0ba6!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/components/layout/forms/SelectList.vue
// module id = 748
// module chunks = 1